<template>
  <section>
    <b-modal
      :active="isShow"
      @close="closeModal"
      has-modal-card
    >
      <form class="lm-forms">
        <div class="modal-card">
          <header
            class="modal-card-head"
            v-if="header"
          >
            <b-icon
              :icon="header.icon"
              size="is-small"
            />
            <div
              class="lr-modal-title"
              v-t="header.title"
            />
          </header>
          <section class="modal-card-body local-lm-hidden-overflow">
            <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <orders-tag
                    v-if="body && body.orderCodes && type !== 'EDIT_REGISTRATION' && type !== 'ADD_DRIVER'"
                    :orders="body.orderCodes"
                    :date="body.date"
                    :type="type"
                  />
                </div>
              </div>
            <div v-if="body && type === 'RESCHEDULE_DATE'">
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <b-field
                    class="lm-label"
                    :label="$t('ModalActions.labelDeliveryDate')"
                  >
                    <b-datepicker
                      :placeholder="$t('ModalActions.datePlaceholder')"
                      :min-date="todayDate"
                      position="is-top-right"
                      icon="calendar-month"
                      class="local-lm-filters-datepicker"
                      v-model.trim="$v.rescheduleData.newDate.$model"
                    />
                  </b-field>
                  <div class="columns local-lm-modal">
                    <div class="column is-12 local-lm-filters">
                      <b-dropdown
                        aria-role="list"
                        class="local-lm-filters"
                        v-model="selectedRescheduleMoment"
                        @active-change="selectDropRescheduleMoment"
                      >
                        <button
                          class="button"
                          type="button"
                          slot="trigger"
                        >
                          <div class="local-lm-filters--placeholder">
                            <template>
                              <span
                                v-if="!selectedRescheduleMoment"
                                v-t="'ModalActions.rescheduleChoise1'"
                              />
                              <span
                                v-else
                                v-t="selectedRescheduleMoment.description"
                              />
                            </template>
                            <b-icon icon="chevron-down" />
                          </div>
                        </button>
                        <b-dropdown-item
                          v-for="(moment, index) in rechedulesMoments"
                          :key="index"
                          :value="moment"
                        >
                          {{ moment.description | upperCase }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </div>

                  <div
                    v-if="visibleRescheduleTypes"
                    class="columns local-lm-modal"
                  >
                    <div class="column is-12 local-lm-filters">
                      <b-dropdown
                        aria-role="list"
                        class="local-lm-filters"
                        v-model="selectedRescheduleTypes"
                        @active-change="selectDropRescheduleTypes"
                      >
                        <button
                          class="button"
                          type="button"
                          slot="trigger"
                        >
                          <div class="local-lm-filters--placeholder">
                            <template>
                              <span
                                v-if="!selectedRescheduleTypes"
                                v-t="'ModalActions.rescheduleChoise2'"
                              />
                              <span
                                v-else
                                v-t="selectedRescheduleTypes.description"
                              />
                            </template>
                            <b-icon icon="chevron-down" />
                          </div>
                        </button>
                        <b-dropdown-item
                          v-for="(type, index) in rescheduleTypes"
                          :key="index"
                          :value="type"
                        >
                          {{ type.description | upperCase }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </div>

                  <div
                    v-if="visibleRescheduleSubTypes"
                    class="columns local-lm-modal"
                  >
                    <div class="column is-12 local-lm-filters">
                      <b-dropdown
                        aria-role="list"
                        class="local-lm-filters"
                        v-model="selectedRescheduleSubTypes"
                        @active-change="selectDropRescheduleSubTypes"
                      >
                        <button
                          class="button"
                          type="button"
                          slot="trigger"
                        >
                          <div class="local-lm-filters--placeholder">
                            <template>
                              <span
                                v-if="!selectedRescheduleSubTypes"
                                v-t="'ModalActions.rescheduleChoise3'"
                              />
                              <span
                                v-else
                                v-t="selectedRescheduleSubTypes.description"
                              />
                            </template>
                            <b-icon icon="chevron-down" />
                          </div>
                        </button>
                        <b-dropdown-item
                          v-for="(subType, index) in rescheduleSubTypes"
                          :key="index"
                          :value="subType"
                        >
                          {{ subType.description | upperCase }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </div>

                  <div
                    v-if="visibleRescheduleDetails"
                    class="columns local-lm-modal"
                  >
                    <div class="column is-12 local-lm-filters">
                      <b-dropdown
                        aria-role="list"
                        class="local-lm-filters"
                        v-model="selectedRescheduleDetails"
                        @active-change="selectDropRescheduleDetails"
                      >
                        <button
                          class="button"
                          type="button"
                          slot="trigger"
                        >
                          <div class="local-lm-filters--placeholder">
                            <template>
                              <span
                                v-if="!selectedRescheduleDetails"
                                v-t="'ModalActions.rescheduleChoise3'"
                              />
                              <span
                                v-else
                                v-t="selectedRescheduleDetails.description"
                              />
                            </template>
                            <b-icon icon="chevron-down" />
                          </div>
                        </button>
                        <b-dropdown-item
                          v-for="(detail, index) in rescheduleDetails"
                          :key="index"
                          :value="detail"
                        >
                          {{ detail.description | upperCase }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="body && type === 'SCHEDULE_PERIOD'">
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <b-field
                    class="lm-label"
                    :label="$t('ModalActions.labelPeriod')"
                  >
                    <b-dropdown
                      v-model.trim="rescheduleData.periodBy"
                      aria-role="list"
                      class="local-lm-filters"
                    >
                      <button
                        class="button"
                        type="button"
                        slot="trigger"
                      >
                        <div class="local-lm-filters--placeholder">
                          <template>
                            <span
                              v-if="!rescheduleData.periodBy"
                              v-t="'ModalActions.orderByChoiseUser3'"
                            />
                            <span
                              v-else
                              v-t="_applySomeExceptions({ name: rescheduleData.periodBy })"
                            />
                          </template>
                          <b-icon icon="chevron-down" />
                        </div>
                      </button>
                      <b-dropdown-item
                        v-for="(schedule, index) in schedules"
                        :key="index"
                        :value="schedule.name"
                      >
                        {{ _applySomeExceptions(schedule) }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-field>
                </div>
              </div>
            </div>
            <div
              v-if="body && type === 'DELIVERED'"
            >
              <div class="columns local-lm-modal">
                <div class="column is-6 local-lm-filters">
                  <b-field
                    class="lm-label"
                    :label="$t('ModalActions.labelDeliveryDisableDate')"
                  >
                    <b-input
                      icon="calendar-month"
                      class="local-lm-filters-datepicker__timepicker"
                      :placeholder="this.dateFormat(todayDate)"
                      disabled
                    />
                  </b-field>
                </div>
                <div class="column is-6 local-lm-filters">
                  <b-field
                    class="lm-label"
                    :label="$t('ModalActions.labelHour')"
                  >
                    <b-timepicker
                      :placeholder="$t('ModalActions.hourPlaceholder')"
                      class="local-lm-filters-datepicker__timepicker"
                      icon="clock"
                      v-model.trim="rescheduleData.newDeliveryHour"
                    />
                  </b-field>
                </div>
              </div>
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <div
                    class="local-lm-filters__little-info"
                    v-if="!pods.length"
                    v-t="'Errors.noPods'"
                  />
                  <div v-else>
                    <div
                      class="local-lm-filters__little-info"
                      v-html="$t('ModalActions.labelPods', { lenPods: pods.length })"
                    />
                    <b-table
                      ref="table"
                      :data="pods"
                      detail-key="index"
                      hoverable
                      narrowed
                      class="local-lm-modal__transports-rules-table"
                    >
                      <template slot-scope="props">
                        <b-table-column
                          field="index"
                          label="l1"
                          width="400"
                        >
                          <template slot="header">
                            {{ $t("ModalActions.labelFile") }}
                          </template>
                          <div>
                            {{ props.row.fileName }}
                          </div>
                        </b-table-column>
                        <b-table-column
                          field="index"
                          label="l2"
                          width="55"
                        >
                          <template slot="header" />
                          <div>
                            <b-button
                              icon-right="file-download-outline"
                              size="is-small"
                              class="local-lm-btn-actions_general-green"
                              @click.prevent="downloadFile(props.row)"
                            />
                          </div>
                        </b-table-column>
                        <b-table-column
                          field="index"
                          label="l3"
                          width="55"
                        >
                          <template slot="header" />
                          <b-button
                            icon-right="trash-can-outline"
                            size="is-small"
                            class="local-lm-btn-actions_general-orange"
                            @click.prevent="deleteFile(props.row.id)"
                          />
                        </b-table-column>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <b-field>
                    <b-upload v-model="rescheduleData.podFile">
                      <a class="button lm-default-btn-outline-green">
                        <b-icon icon="image-plus" />
                        <span v-t="'ModalActions.labelLoadPOD'" />
                      </a>
                    </b-upload>
                    <span class="file-name" v-if="rescheduleData.podFile">
                      {{ rescheduleData.podFile.name }}
                    </span>
                  </b-field>
                </div>
              </div>
            </div>
            <div v-if="body && type === 'TO_REVERT'">
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <div v-t="'ModalActions.restore'" />
                </div>
              </div>
            </div>
            <div v-if="body && type === 'ON_EXPEDITION'">
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <div v-t="'ModalActions.collected'" />
                </div>
              </div>
            </div>

            <div v-if="body && type === 'SHOW_UPLOAD_POD'">
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <div
                    class="local-lm-filters__little-info"
                    v-if="!pods.length"
                    v-t="'Errors.noPods'"
                  />
                  <div v-else>
                    <div
                      class="local-lm-filters__little-info"
                      v-html="$t('ModalActions.labelPods', { lenPods: pods.length })"
                    />
                    <b-table
                      ref="table"
                      :data="pods"
                      detail-key="index"
                      hoverable
                      narrowed
                      class="local-lm-modal__transports-rules-table"
                    >
                      <template slot-scope="props">
                        <b-table-column
                          field="index"
                          label="l1"
                          width="400"
                        >
                          <template slot="header">
                            {{ $t("ModalActions.labelFile") }}
                          </template>
                          <div>
                            {{ props.row.fileName }}
                          </div>
                        </b-table-column>
                        <b-table-column
                          field="index"
                          label="l2"
                          width="55"
                        >
                          <template slot="header" />
                          <div>
                            <b-button
                              icon-right="file-download-outline"
                              size="is-small"
                              class="local-lm-btn-actions_general-green"
                              @click.prevent="downloadFile(props.row)"
                            />
                          </div>
                        </b-table-column>
                        <b-table-column
                          field="index"
                          label="l3"
                          width="55"
                        >
                          <template slot="header" />
                          <b-button
                            icon-right="trash-can-outline"
                            size="is-small"
                            class="local-lm-btn-actions_general-orange"
                            @click.prevent="deleteFile(props.row.id)"
                          />
                        </b-table-column>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <b-field>
                    <b-upload v-model="rescheduleData.podFile">
                      <a class="button lm-default-btn-outline-green">
                        <b-icon icon="image-plus" />
                        <span v-t="'ModalActions.labelLoadPOD'" />
                      </a>
                    </b-upload>
                    <span class="file-name" v-if="rescheduleData.podFile">
                      {{ rescheduleData.podFile.name }}
                    </span>
                  </b-field>
                </div>
              </div>
            </div>

            <div v-if="type === 'INCIDENCE'">
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <b-dropdown
                    aria-role="list"
                    class="local-lm-filters"
                    v-model="selectedMoment"
                    @active-change="selectDropMoment"
                  >
                    <button
                      class="button"
                      type="button"
                      slot="trigger"
                    >
                      <div class="local-lm-filters--placeholder">
                        <template>
                          <span
                            v-if="!selectedMoment"
                            v-t="'ModalActions.incidenceChoise1'"
                          />
                          <span
                            v-else
                            v-t="selectedMoment.description"
                          />
                        </template>
                        <b-icon icon="chevron-down" />
                      </div>
                    </button>
                    <b-dropdown-item
                      v-for="(moment, index) in incidenceMoments"
                      :key="index"
                      :value="moment"
                    >
                      {{ moment.description | upperCase }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>

              <div
                v-if="visibleType"
                class="columns local-lm-modal"
              >
                <div class="column is-12 local-lm-filters">
                  <b-dropdown
                    aria-role="list"
                    class="local-lm-filters"
                    v-model="selectedType"
                    @active-change="selectDropType"
                  >
                    <button
                      class="button"
                      type="button"
                      slot="trigger"
                    >
                      <div class="local-lm-filters--placeholder">
                        <template>
                          <span
                            v-if="!selectedType"
                            v-t="'ModalActions.incidenceChoise2'"
                          />
                          <span
                            v-else
                            v-t="selectedType.description"
                          />
                        </template>
                        <b-icon icon="chevron-down" />
                      </div>
                    </button>
                    <b-dropdown-item
                      v-for="(type, index) in incidentsTypes"
                      :key="index"
                      :value="type"
                    >
                      {{ type.description | upperCase }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>

              <div
                v-if="visibleSubType"
                class="columns local-lm-modal"
              >
                <div class="column is-12 local-lm-filters">
                  <b-dropdown
                    aria-role="list"
                    class="local-lm-filters"
                    v-model="selectedSubType"
                    @active-change="selectDropSubType"
                  >
                    <button
                      class="button"
                      type="button"
                      slot="trigger"
                    >
                      <div class="local-lm-filters--placeholder">
                        <template>
                          <span
                            v-if="!selectedSubType"
                            v-t="'ModalActions.incidenceChoise3'"
                          />
                          <span
                            v-else
                            v-t="selectedSubType.description"
                          />
                        </template>
                        <b-icon icon="chevron-down" />
                      </div>
                    </button>
                    <b-dropdown-item
                      v-for="(subtype, index) in incidentsSubTypes"
                      :key="index"
                      :value="subtype"
                    >
                      {{ subtype.description | upperCase }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>

              <div
                v-if="visibleMotiv"
                class="columns local-lm-modal"
              >
                <div class="column is-12 local-lm-filters">
                  <b-dropdown
                    aria-role="list"
                    class="local-lm-filters"
                    v-model="selectedMotiv"
                    @active-change="selectDropMotiv"
                  >
                    <button
                      class="button"
                      type="button"
                      slot="trigger"
                    >
                      <div class="local-lm-filters--placeholder">
                        <template>
                          <span
                            v-if="!selectedMotiv"
                            v-t="'ModalActions.incidenceChoise4'"
                          />
                          <span
                            v-else
                            v-t="selectedMotiv.description"
                          />
                        </template>
                        <b-icon icon="chevron-down" />
                      </div>
                    </button>
                    <b-dropdown-item
                      v-for="(motiv, index) in incidentsMotivs"
                      :key="index"
                      :value="motiv"
                    >
                      {{ motiv.description | upperCase }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>

              <div
                v-if="visibleBtnPhoto"
                class="columns local-lm-modal"
              >
                <div class="column is-12 local-lm-filters">
                  <b-field>
                    <b-upload
                      v-model="file"
                      @input="addPhoto"
                    >
                      <a class="button lm-default-btn-outline-green">
                        <b-icon icon="camera-plus-outline" />
                        <span v-t="'ModalActions.photo'" />
                      </a>
                    </b-upload>
                    <span
                      class="file-name"
                      v-if="file"
                    >
                      {{ file.name }}
                    </span>
                  </b-field>
                </div>
              </div>
            </div>
            <div v-if="body && type === 'EDIT_REGISTRATION'">
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <b-field
                    class="lm-label"
                    :label="$t('ModalActions.labelEditRegistration')"
                    :type="validateRegistration"
                    :message="errorRegistration"
                  >
                    <b-input
                      v-model.trim="$v.editRegistration.$model"
                      class="local-lm-filters--input lm-xpecial__input-up"
                      type="text"
                      maxlength="8"
                    />
                  </b-field>
                </div>
              </div>
            </div>
            <div v-if="body && type === 'VEHICLE_REGISTRATION'">
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <b-dropdown
                    aria-role="list"
                    class="local-lm-filters"
                    v-model="rescheduleData.vehicleRegistration"
                  >
                    <button
                      class="button"
                      type="button"
                      slot="trigger"
                    >
                      <div class="local-lm-filters--placeholder">
                        <template>
                          <span
                            v-if="!rescheduleData.vehicleRegistration"
                            v-t="'ModalActions.registrationChoise1'"
                          />
                          <span
                            v-if="rescheduleData.vehicleRegistration"
                            v-t="getRegistration(rescheduleData.vehicleRegistration).description"
                          />
                        </template>
                        <b-icon icon="chevron-down" />
                      </div>
                    </button>
                    <b-dropdown-item
                      v-for="(_registration, index) in registrations"
                      :key="index"
                      :value="_registration.id"
                    >
                      {{ _registration.registration | upperCase }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div v-if="body && type === 'ADD_DRIVER'">
              <div class="columns local-lm-modal">
                <div class="column is-12 local-lm-filters">
                  <b-dropdown
                    aria-role="list"
                    class="local-lm-filters"
                    v-model="driverID"
                  >
                    <button
                      class="button"
                      type="button"
                      slot="trigger"
                    >
                      <div class="local-lm-filters--placeholder">
                        <template>
                          <span
                            v-if="!driverID"
                            v-t="'ModalActions.addDriverChoise1'"
                          />
                          <span
                            v-if="driverID"
                            v-t="getDriver(driverID).fullName"
                          />
                        </template>
                        <b-icon icon="chevron-down" />
                      </div>
                    </button>
                    <b-dropdown-item
                      v-for="(driver, index) in drivers"
                      :key="index"
                      :value="driver.id"
                    >
                      {{ driver.fullName | upperCase }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>

            <div v-if="body && type === 'RESCHEDULE_DATE_TIME'">
              <div class="columns local-lm-modal">
                <div class="column is-6 local-lm-filters">
                  <b-field
                    class="lm-label"
                    :label="$t('ModalActions.labelConfirmDate')"
                  >
                    <b-datepicker
                      :placeholder="$t('ModalActions.datePlaceholder')"
                      :min-date="todayDate"
                      position="is-top-right"
                      icon="calendar-month"
                      class="local-lm-filters-datepicker"
                      v-model.trim="$v.rescheduleData.newDate.$model"
                    />
                  </b-field>
                </div>
                <div class="column is-6 local-lm-filters">
                  <b-field
                    class="lm-label"
                    :label="$t('ModalActions.labelPeriod')"
                  >
                    <b-dropdown
                      v-model.trim="rescheduleData.periodBy"
                      aria-role="list"
                      class="local-lm-filters"
                    >
                      <button
                        class="button"
                        type="button"
                        slot="trigger"
                      >
                        <div class="local-lm-filters--placeholder">
                          <template>
                            <span
                              v-if="!rescheduleData.periodBy"
                              v-t="'ModalActions.orderByChoiseUser3'"
                            />
                            <span
                              v-else
                              v-t="_applySomeExceptions({ name: rescheduleData.periodBy })"
                            />
                          </template>
                          <b-icon icon="chevron-down" />
                        </div>
                      </button>
                      <b-dropdown-item
                        v-for="(schedule, index) in schedules"
                        :key="index"
                        :value="schedule.name"
                      >
                        {{ _applySomeExceptions(schedule) }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-field>
                </div>
              </div>
            </div>
          </section>
          <footer
            class="modal-card-foot"
            v-if="footer"
          >
            <div
              class="buttons"
              v-if="footer.left"
            >
              <b-button
                class="lm-default-btn-outline-green"
                v-t="'Common.cancel'"
                v-if="footer.left.cancelBtn"
                @click.prevent="closeModal"
              />
            </div>
            <div
              class="buttons local-lr-pull-right"
              v-if="footer.right"
            >
              <b-button
                class="lm-default-btn-outline-green"
                :class="{
                  disable: reportRechedule,
                  active: !reportRechedule,
                }"
                v-t="'Common.reschedule'"
                v-if="footer.right.rescheduleBtn"
                :disabled="!reportRechedule"
                @click.prevent="submitReschedule"
              />
              <b-button
                class="lm-default-btn-outline-green"
                :class="{
                  disable: !rescheduleData.periodBy,
                  active: rescheduleData.periodBy,
                }"
                v-t="'Common.schedule'"
                v-if="footer.right.scheduleBtn"
                :disabled="!rescheduleData.periodBy"
                @click.prevent="submitData"
              />
              <b-button
                class="lm-default-btn-outline-green"
                :class="{
                  disable: !rescheduleData.newDeliveryHour,
                  active: rescheduleData.newDeliveryHour,
                }"
                v-t="'Common.confirm'"
                v-if="footer.right.confirmBtn"
                :disabled="!rescheduleData.newDeliveryHour"
                @click.prevent="submitData"
              />
              <b-button
                class="lm-default-btn-outline-green"
                v-t="'Common.restore'"
                v-if="footer.right.restoreBtn"
                @click.prevent="submitData"
              />
              <b-button
                class="lm-default-btn-outline-green"
                v-t="'Common.send'"
                v-if="footer.right.collectedBtn"
                @click.prevent="submitData"
              />
              <b-button
                class="lm-default-btn-outline-green"
                :class="{
                  disable: !reportIncidence,
                  active: reportIncidence,
                }"
                v-t="'Common.report'"
                v-if="footer.right.reportBtn"
                :disabled="!reportIncidence"
                @click.prevent="submitIncidence"
              />
              <b-button
                class="lm-default-btn-outline-green"
                :class="{
                  disable: !$v.editRegistration.confirm || !$v.editRegistration.$model,
                  active: $v.editRegistration.confirm,
                }"
                v-t="'Common.confirm'"
                v-if="footer.right.editRegistrationBtn"
                :disabled="!$v.editRegistration.confirm || !$v.editRegistration.$model"
                @click.prevent="submitRegistration"
              />
              <b-button
                class="lm-default-btn-outline-green"
                v-t="'Common.confirm'"
                v-if="footer.right.registrationBtn"
                :disabled="!rescheduleData.vehicleRegistration"
                @click.prevent="submitData"
              />
              <b-button
                class="lm-default-btn-outline-green"
                v-t="'Common.confirm'"
                v-if="footer.right.addDriverBtn"
                :disabled="!driverID"
                @click.prevent="submitDriver"
              />
              <b-button
                class="lm-default-btn-outline-green"
                v-t="'Common.reschedule'"
                v-if="footer.right.rescheduleDateTimeBtn"
                :disabled="!rescheduleData.newDate || !rescheduleData.periodBy"
                @click.prevent="submitRescheduleDateTime"
              />
              <b-button
                class="lm-default-btn-outline-green"
                v-t="'Common.confirm'"
                v-if="footer.right.showUploadBtn"
                @click.prevent="submitUploadFile"
              />
            </div>
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, helpers } from 'vuelidate/lib/validators'
import { mixin } from '@/mixins'
import OrdersTag from '@/components/OrdersTag'

export default {
  name: 'ModalActions',
  mixins: [
    mixin.dates,
    mixin.notifications,
    mixin.images
  ],
  components: {
    OrdersTag
  },
  computed: {
    ...mapGetters('modal', [
      'isShow',
      'content'
    ]),
    ...mapGetters('filters', [
      'filtersIncidencesMoments',
      'filtersRechedules',
      'filtersSchedules',
      'pods'
    ]),
    ...mapGetters('user', [
      'registrations',
      'drivers'
    ]),
    header () {
      return this.content.header
    },
    body () {
      return this.content.body
    },
    footer () {
      return this.content.footer
    },
    type () {
      return this.content.type
    },
    show () {
      return this.isShow
    },
    incidenceMoments () {
      return this.filtersIncidencesMoments.filter(r => r.level === 'MOMENT')
    },
    rechedulesMoments () {
      return this.filtersRechedules.filter(r => r.level === 'MOMENT')
    },
    schedules () {
      return this.filtersSchedules
    },
    validateRegistration () {
      return !this.$v.editRegistration.confirm
        ? 'is-danger'
        : null
    },
    errorRegistration () {
      return !this.$v.editRegistration.confirm
        ? this.$t('Errors.validRegistration')
        : null
    }
  },
  data () {
    const today = new Date()
    const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate())

    return {
      todayDate,
      selectedMoment: '',
      selectedType: '',
      selectedSubType: '',
      selectedMotiv: '',
      selectedRescheduleMoment: '',
      selectedRescheduleTypes: '',
      selectedRescheduleSubTypes: '',
      selectedRescheduleDetails: '',
      visibleType: false,
      visibleSubType: false,
      visibleMotiv: false,
      visibleRescheduleTypes: false,
      visibleBtnPhoto: false,
      visibleRescheduleSubTypes: false,
      visibleRescheduleDetails: false,
      reportIncidence: false,
      moments: [],
      reportRechedule: false,
      rescheduleTypes: [],
      incidentsTypes: [],
      incidentsSubTypes: [],
      incidentsMotivs: [],
      oldType: '',
      oldSubType: '',
      oldMotiv: '',
      file: null,
      imgBase64: '',
      oldRescheduleReassonMotiv: '',
      editRegistration: '',
      driverID: '',
      rescheduleData: {
        newDate: todayDate,
        vehicleRegistration: '',
        newDeliveryHour: '',
        periodBy: '',
        newDeliveryDate: this.dateFormat(today),
        podFile: null
      }
    }
  },
  watch: {
    show (visible) {
      const today = new Date()

      this.rescheduleData.newDate = today
      this.rescheduleData.periodBy = ''
      this.rescheduleData.newDeliveryHour = ''
      this.rescheduleData.newDeliveryDate = this.dateFormat(today)
      this.rescheduleData.podFile = null
      this.visibleType = false
      this.selectedMoment = ''
      this.visibleSubType = false
      this.selectedType = ''
      this.visibleMotiv = false
      this.selectedMotiv = ''
      this.visibleRescheduleType = false
      this.selectedRescheduleMoment = ''
      this.selectedRescheduleType = ''
      this.visibleBtnPhoto = false
      this.file = null
      this.reportIncidence = false
      this.imgBase64 = ''
      this.reportRechedule = false
      this.editRegistration = ''
      this.selectedRegistration = ''
      this.driverID = ''
      this.visibleRescheduleSubTypes = false
      this.visibleRescheduleTypes = false
    },
    body (arr) {
      if (this.type === 'EDIT_REGISTRATION') this.editRegistration = arr.orderCodes[0]
    },
    deep: true
  },
  methods: {
    closeModal () {
      this.$store.dispatch('modal/disable')
    },
    async selectDropMoment () {
      if (!this.selectedMoment) return
      this._cleanReschedules(this.selectedMoment.level)

      const types = this._filterAllIncidentsTypes(this.selectedMoment)
      if (!types.length) this.reportIncidence = true

      if (this.selectedMoment.requiresProofOfImage) {
        this.visibleBtnPhoto = true
        this.reportIncidence = false
      }

      if (types && types.length > 0) {
        this.visibleType = true
        this.incidentsTypes = types
      }
    },
    async selectDropType () {
      if (!this.selectedType) return
      this._cleanReschedules(this.selectedType.level)

      const subTypes = this._filterAllIncidentsTypes(this.selectedType)
      if (!subTypes.length) this.reportIncidence = true

      if (this.selectedType.requiresProofOfImage) {
        this.visibleBtnPhoto = true
        this.reportIncidence = false
      }

      if (subTypes && subTypes.length > 0) {
        this.visibleSubType = true
        this.incidentsSubTypes = subTypes
      }
    },
    async selectDropSubType () {
      if (!this.selectedSubType) return
      this._cleanReschedules(this.selectedSubType.level)

      const motivs = this._filterAllIncidentsTypes(this.selectedSubType)
      if (!motivs.length) this.reportIncidence = true

      if (this.selectedSubType.requiresProofOfImage) {
        this.visibleBtnPhoto = true
        this.reportIncidence = false
      }

      if (motivs && motivs.length > 0) {
        this.visibleMotiv = true
        this.incidentsMotivs = motivs
      }
    },
    async selectDropMotiv () {
      if (!this.selectedMotiv) return
      if (this.selectedMotiv.requiresProofOfImage) this.visibleBtnPhoto = true
      this.reportIncidence = true
    },
    async addPhoto () {
      this.imgBase64 = await this.imageAsBase64(this.file)
      if (this.imgBase64) this.reportIncidence = true
    },
    _filterAllSchudellingTypes (selects) {
      return this.filtersRechedules
        .filter(r => (r.idFather === selects.idChild && r.levelFather === selects.level))
    },

    _filterAllIncidentsTypes (selects) {
      return this.filtersIncidencesMoments
        .filter(r => (r.idFather === selects.idChild && r.levelFather === selects.level))
    },
    _cleanReschedules (level) {
      if (level === 'SUBTYPE' || level === 'TYPE' || level === 'MOMENT') {
        this.visibleRescheduleDetails = false
        this.selectedRescheduleDetails = ''
        this.rescheduleDetails = []

        this.visibleMotiv = false
        this.selectedMotiv = ''
        this.incidentsMotivs = []
      }

      if (level === 'TYPE' || level === 'MOMENT') {
        this.visibleRescheduleSubTypes = false
        this.selectedRescheduleSubTypes = ''
        this.rescheduleSubTypes = []

        this.visibleSubType = false
        this.incidentsSubTypes = []
        this.selectedSubType = ''
      }

      if (level === 'MOMENT') {
        this.visibleRescheduleTypes = false
        this.selectedRescheduleTypes = ''
        this.rescheduleTypes = []

        this.visibleType = false
        this.selectedType = ''
        this.incidentsTypes = []
      }

      this.reportRechedule = false
      this.reportIncidence = false
      this.visibleBtnPhoto = false
      this.imgBase64 = ''
    },
    selectDropRescheduleMoment () {
      if (!this.selectedRescheduleMoment) return
      this._cleanReschedules(this.selectedRescheduleMoment.level)

      const types = this._filterAllSchudellingTypes(this.selectedRescheduleMoment)
      if (!types.length) this.reportRechedule = true
      if (types && types.length > 0) {
        this.visibleRescheduleTypes = true
        this.rescheduleTypes = types
      }
    },
    selectDropRescheduleTypes () {
      if (!this.selectedRescheduleTypes) return
      this._cleanReschedules(this.selectedRescheduleTypes.level)

      const subTypes = this._filterAllSchudellingTypes(this.selectedRescheduleTypes)
      if (!subTypes.length) this.reportRechedule = true
      if (subTypes && subTypes.length > 0) {
        this.visibleRescheduleSubTypes = true
        this.rescheduleSubTypes = subTypes
      }
    },
    selectDropRescheduleSubTypes () {
      if (!this.selectedRescheduleSubTypes) return
      this._cleanReschedules(this.selectedRescheduleSubTypes.level)

      const details = this._filterAllSchudellingTypes(this.selectedRescheduleSubTypes)
      if (!details.length) this.reportRechedule = true
      if (details && details.length > 0) {
        this.visibleRescheduleDetails = true
        this.rescheduleDetails = details
      }
    },
    selectDropRescheduleDetails () {
      if (!this.selectedRescheduleDetails) return
      this.reportRechedule = true
    },
    getRegistration (code) {
      const _registration = this.registrations.find(r => r.id === code)
      const blob = _registration
        ? {
          description: _registration.registration.toUpperCase(),
          id: _registration.id
        }
        : ''

      return blob
    },
    getDriver (code) {
      const driver = this.drivers.find(d => d.id === code)
      const blob = driver
        ? {
          fullName: driver.fullName.toUpperCase(),
          id: driver.id
        }
        : ''

      return blob
    },
    async submitData () {
      this.$v.$touch()

      if (this.$v.$invalid &&
       !this.rescheduleData.periodBy &&
       !this.rescheduleData.newDeliveryHour &&
       this.type !== 'TO_REVERT' &&
       this.type !== 'ON_EXPEDITION' &&
       this.type !== 'VEHICLE_REGISTRATION'
      ) return false

      if (this.rescheduleData.vehicleRegistration) {
        this.rescheduleData.vehicleRegistration = this.getRegistration(this.rescheduleData.vehicleRegistration).description
      }

      const params = {
        data: this.rescheduleData,
        orders: this.body.orderIds,
        orderCodes: this.body.customerOrderCodes,
        storeCodes: this.body.storeCodes,
        type: this.type
      }

      if (this.rescheduleData.podFile) params.podFile = await this.imageAsBase64(this.rescheduleData.podFile)

      const changes = await this.$store.dispatch('orders/setChanges', params)
      if (!changes.level) return this.wrong(this.$t(changes.errorText))

      this.sucess(this.$t('Common.success'))
      this.$eventBus.$emit('closeModal')
      this.closeModal()
    },
    async submitUploadFile () {
      if (!this.rescheduleData.podFile) return false
      const podFile = await this.imageAsBase64(this.rescheduleData.podFile)

      const params = {
        orders: this.body.orderIds,
        type: this.type,
        podFile
      }

      const uploadFile = await this.$store.dispatch('orders/uploadPodFile', params)
      if (!uploadFile.level) return this.wrong(this.$t(uploadFile.errorText))

      this.sucess(this.$t('Common.success'))
      this.$eventBus.$emit('closeModal')
      this.closeModal()
    },
    async submitIncidence () {
      const moments = this.selectedMoment
      const types = this.selectedType
      const subTypes = this.selectedSubType
      const motivs = this.selectedMotiv
      const file = this.imgBase64
      const action = this.$store.getters['orders/actions']

      const params = {
        orders: this.body.orderIds,
        moments,
        types,
        subTypes,
        motivs,
        file,
        status: action.reportIncidence
      }

      const changes = await this.$store.dispatch('orders/setIncidence', params)
      if (!changes.level) return this.wrong(this.$t(changes.errorText))

      this.sucess(this.$t('Common.success'))
      this.$eventBus.$emit('closeModal')
      this.closeModal()
    },
    async submitReschedule () {
      if (this.$v.rescheduleData.newDate.$invalid) return this.wrong(this.$t('Errors.warningAllFieldsWithData'))

      const moments = this.selectedRescheduleMoment
      const types = this.selectedRescheduleTypes
      const subTypes = this.selectedRescheduleSubTypes
      const details = this.selectedRescheduleDetails
      const action = this.$store.getters['orders/actions']

      const params = {
        orders: this.body.orderIds,
        date: this.rescheduleData.newDate,
        moments,
        types,
        subTypes,
        details,
        status: action.reportReschedule
      }

      const changes = await this.$store.dispatch('orders/setReschedule', params)
      if (!changes.level) return this.wrong(this.$t(changes.errorText))

      this.sucess(this.$t('Common.success'))
      this.$eventBus.$emit('closeModal')
      this.closeModal()
    },
    async submitRescheduleDateTime  () {
      if (this.$v.rescheduleData.newDate.$invalid || !this.rescheduleData.periodBy) return this.wrong(this.$t('Errors.warningAllFieldsWithData'))

      const params = {
        orders: this.body.orderIds,
        date: this.rescheduleData.newDate,
        periodBy: this.rescheduleData.periodBy
      }

      const changes = await this.$store.dispatch('orders/setRescheduleDateTime', params)
      if (!changes.level) return this.wrong(this.$t(changes.errorText))

      this.sucess(this.$t('Common.success'))
      this.$eventBus.$emit('closeModal')
      this.closeModal()
    },
    async submitRegistration () {
      this.$v.$touch()

      const action = this.$store.getters['orders/actions']
      const user = await this.$store.getters['user/status'].info
      const params = {
        id: user.operators[0],
        registrationId: this.body.orderIds[0],
        registration: this.editRegistration.toUpperCase(),
        status: action.editRegistration
      }

      const changes = await this.$store.dispatch('user/setRegistration', params)
      if (!changes.level) return this.wrong(this.$t(changes.errorText))

      this.sucess(this.$t('Common.success'))
      this.$eventBus.$emit('registration')
      this.closeModal()
    },
    async submitDriver () {
      this.$v.$touch()

      if (!this.driverID) {
        this.wrong(this.$t('Errors.warningAllFieldsWithData'))
        return false
      }

      const params = {
        id: this.driverID,
        vehicles: this.body.orderIds
      }

      const addDriver = await this.$store.dispatch('user/setDriver', params)
      if (!addDriver.level) return this.wrong(this.$t(addDriver.errorText))

      const sucessChangedDriverText = this.$t('ModalActions.changedRegistration', { registration: this.body.orderCodes, driverName: addDriver.driverName })
      const sucessRemovedDriverText = addDriver.lastDriver ? this.$t('ModalActions.removeRegistration', { lastDriver: addDriver.lastDriver }) : ''

      this.sucess(`${sucessChangedDriverText} ${sucessRemovedDriverText}`)
      this.$eventBus.$emit('registration')
      this.closeModal()
    },
    async downloadFile (file) {
      await this.$store.dispatch('filters/downloadPodFile', file)
    },
    async deleteFile (id) {
      const result = await this.$store.dispatch('filters/deletePodFile', id)
      if (!result.level) this.wrong(this.$t('Errors.somethingWrong'))

      this.sucess(this.$t('Common.success'))
    },
    _applySomeExceptions ({ name }) {
      if (!name) return
      // ! MOVIMENT-1338 apply this exception until these slots was deleted from the system
      const exceptions = ['MORNING', 'AFTERNOON']
      if (exceptions.includes(name)) return this.$t(`ModalActions.${name}`).toUpperCase()

      return name.toUpperCase()
    }
  },
  validations: {
    rescheduleData: {
      newDate: { required }
    },
    editRegistration: {
      required,
      confirm (registration) {
        const regex = /^[A-Za-z0-9]{2}[-][A-Za-z0-9]{2}[-][A-Za-z0-9]{2}/g
        const alpha = helpers.regex('alpha', regex)

        return !helpers.req(registration) || alpha(registration)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalActions.vue